import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import Setup from "./Setup";
import Active from "./Active";
import { useLogout } from "../Redux/Auth/Logout";

interface NavProps {
  current: Page;
  goto: (page: Page) => void;
}

enum Page {
  home = "Home",
  setup = "Setup",
  active = "Active",
}

const PAGES = [Page.home, Page.setup, Page.active];

export default () => {
  const [page, setPage] = useState(Page.home);
  const logout = useLogout();
  const Component = resolvePageComponent(page);
  return (
    <div>
      <h1>{page}</h1>
      <Nav current={page} goto={setPage} />
      <Component />
      <p>
        <button onClick={() => logout()}>Logout</button>
      </p>
      {page === Page.home && <DeleteAccount />}
    </div>
  );
};

const resolvePageComponent = (page: Page): (() => JSX.Element) => {
  switch (page) {
    case Page.home:
      return Home;
    case Page.setup:
      return Setup;
    case Page.active:
      return Active;
  }
};

const Nav = ({ current, goto }: NavProps) => (
  <ul>
    {PAGES.map((page) => (
      <li key={page}>
        <button onClick={() => goto(page)} disabled={page === current}>
          {page}
        </button>
      </li>
    ))}
  </ul>
);

const Home = () => {
  const { loading, error, data } = useQuery(gql`
    query {
      me {
        username
        hasOtp
        deviceType
      }
    }
  `);
  if (error) return <span>{error}</span>;
  return (
    <div>
      <h2>Hello {data?.me?.username || "..."}</h2>
      {loading || (
        <CurrentOTP
          hasOtp={data?.me?.hasOtp}
          deviceType={data?.me?.deviceType}
        />
      )}
    </div>
  );
};

interface CurrentOTPProps {
  hasOtp: boolean;
  deviceType: string | null;
}

const CurrentOTP = ({ hasOtp, deviceType }: CurrentOTPProps) =>
  hasOtp ? (
    <span>You have OTP set up on a {deviceType || "<unknown>"} device</span>
  ) : (
    <span>You do not have OTP set up</span>
  );

const DeleteAccount = () => {
  const logout = useLogout();
  const [clicked, setClicked] = useState(false);
  const [deleteRemotely, { called }] = useMutation(
    gql`
      mutation DeleteAccount {
        deleteAccount {
          success
        }
      }
    `,
    {
      onCompleted: () => logout(),
    },
  );
  if (called) return <span>Deleting...</span>;
  if (clicked)
    return (
      <button
        id="confirm-delete-account-button"
        onClick={() => deleteRemotely()}
        disabled={called}
      >
        Are you sure?
      </button>
    );
  return (
    <button id="delete-account-button" onClick={() => setClicked(true)}>
      Delete account
    </button>
  );
};
